import React, {
    useCallback,
    useEffect,
    useRef,
    useState
} from "react";
import {
    Tooltip,
    TooltipProps
} from "@mui/material";

type ResponsiveToolTipProps = Omit<TooltipProps,
    "disableFocusListener" | "disableHoverListener" |
    "disableTouchListener" | "onClick" |
    "onClose" | "open"
>;

export const ResponsiveToolTip = ({ children, ...props }: ResponsiveToolTipProps) => {
    const [open, setOpen] = useState(false);
    const clearCloseTooltipIntervalRef = useRef<NodeJS.Timeout | undefined>(undefined);

    const handleClick = useCallback(() => {
        if (clearCloseTooltipIntervalRef.current) {
            clearTimeout(clearCloseTooltipIntervalRef.current);
        }
        setOpen(true);
        const closeTooltip = setTimeout(() => {
            setOpen(false);
        }, 700);
        clearCloseTooltipIntervalRef.current = closeTooltip;
    }, []);

    useEffect(() => {
        return () => {
            if (clearCloseTooltipIntervalRef.current) {
                clearTimeout(clearCloseTooltipIntervalRef.current);
            }
        };
    }, []);

    return (
        <Tooltip
            {...props}
            disableFocusListener
            disableHoverListener
            disableTouchListener
            PopperProps={{
                ...props.PopperProps,
                disablePortal: true
            }}
            onClick={handleClick}
            onClose={() => setOpen(false)}
            open={open}
        >
            {children}
        </Tooltip>
    );
};